import { ConstraintConfigType } from "types/ConstraintsTypes";
import { InputConstraints } from "../../InputConstraints";
import mainStyles from "style/main.module.scss";
export const GridItemWithRemove: React.FC<{
  cd: ConstraintConfigType;
  cv1: string;
  cv2?: string;
  fv: any;
  ohi: any;
  marginTop?: number;
  notEditableValue?: { value: string; label: string };
  onRemove: () => void;
  sectionKey: string;
}> = ({
  cd,
  cv1,
  cv2,
  fv,
  ohi,
  marginTop = 24,
  notEditableValue = null,
  onRemove,
  sectionKey,
}) => {
  return (
    <>
      <div
        className={mainStyles.gridItem}
        style={{ marginTop: marginTop, gridColumn: "span 2" }}
      >
        <div className="flex w-full items-center">
          <span
            className="flex-1 overflow-hidden text-ellipsis break-words pr-2"
            style={{ marginBottom: 10 }}
          >
            {cd[cv1].label}
            {cd[cv1].notWithTopLabel && cd[cv1].type === "percentage" && (
              <span> %</span>
            )}
          </span>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            className="text-red-500 hover:text-red-700 flex-shrink-0 cursor-pointer focus:outline-none"
            aria-label="Remove item"
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className={mainStyles.gridContainer1x2}>
        <div className={mainStyles.gridItem}>
          <div className="flex items-center space-x-2">
            {!cd[cv1].notWithTopLabel && (
              <div className={mainStyles.minMax}>
                Min {cd[cv1].type === "percentage" && <span> %</span>}
              </div>
            )}

            <InputConstraints
              configData={cd}
              formValues={fv}
              id={cv1}
              sectionKey={sectionKey}
              onChange={ohi}
            />
          </div>
        </div>
        {cv2 && (
          <div className={mainStyles.gridItem}>
            <div className="flex items-center space-x-2">
              {!notEditableValue && (
                <div className={mainStyles.minMax}>
                  Max {cd[cv1].type === "percentage" && <span> %</span>}
                </div>
              )}
              {notEditableValue && (
                <div className={mainStyles.minMax}>
                  {notEditableValue.label}
                </div>
              )}

              <InputConstraints
                configData={cd}
                formValues={fv}
                id={cv2}
                sectionKey={sectionKey}
                onChange={ohi}
                notEditableValue={
                  notEditableValue ? notEditableValue.value : null
                }
              />
            </div>
          </div>
        )}
        {!cv2 && <div className={mainStyles.gridItem}>{/* Empty cell */}</div>}
      </div>
    </>
  );
};
